module.exports = __webpack_public_path__ + "static/favicon-f8d7090d2121a303edf8b3aacdedd869.png";